import firebase from 'firebase/app'
import auth from '@/firebase/auth'
import db from '@/firebase/firestore'

const state = {
    milestones: [],
}

const getters = {
    milestones: (state) => state.milestones,
}

const mutations = {
    ADD_MILESTONE: (state, payload) => {
        state.milestones.push(payload)
    },
    ADD_MILESTONES: (state, payload) => {
        state.milestones = payload
    },
    EDIT_MILESTONE: (state, payload) => {
        state.milestones = state.milestones.map(milestone => {
            if (milestone.id === payload.id) {
                return {
                    ...milestone,
                    ...payload,
                }
            }

            return milestone
        })
    },
    DELETE_MILESTONE: (state, uid) => {
        state.milestones = state.milestones.filter(milestone => milestone.id !== uid)
    },
}

const actions = {
    load: ({ commit }) => {
        const list = []

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/milestones/milestones`)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            list.push({
                                ...doc.data(),
                                id: doc.id,
                            })
                        })
                    })
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'milestone/index.js', 56, err))
                commit('ADD_MILESTONES', list)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'milestone/index.js', 59, err))
    },
    add: ({ commit }, payload) => {
        const data = {
            ...payload,
            createdUser: auth.currentUser.uid,
            createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        }

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/milestones/milestones`)
                    .add(data)
                    .then(doc => commit('ADD_MILESTONE', { ...data, id: doc.id }))
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 75, err))
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'milestone/index.js', 78, err))
    },
    edit: ({ commit }, payload) => {
        const data = {
            ...payload,
            updatedUser: auth.currentUser.uid,
            updatedDate: firebase.firestore.FieldValue.serverTimestamp(),
        }
        const dataToSave = { ...data }

        const uid = dataToSave.id
        delete dataToSave.id

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/milestones/milestones`)
                    .doc(uid)
                    .update(dataToSave)
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 96, err))

                commit('EDIT_MILESTONE', data)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'milestone/index.js', 100, err))
    },
    delete: ({ commit }, uid) => {
        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/milestones/milestones`)
                    .doc(uid)
                    .delete()
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 111, err))

                commit('DELETE_MILESTONE', uid)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'milestone/index.js', 115, err))
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
